export default {
  title: 'Guaranteed Ride',
  guaranteedRideHome: 'Guaranteed Ride Home',
  rideRemaining: 'kalan yolculuk hakkı, son kullanma tarihi',
  ridesRemaining: 'kalan yolculuk hakkı, son kullanma tarihi',
  requestRide: 'Yolculuk Talep Et',
  recentPasses: 'Son Yolculuklar',
  noRecentPasses: 'Henüz bir yolculuk kaydı bulunmamaktadır',
  used: 'Kullanıldı',
  expired: 'Süresi Doldu',
  openLyft: "Lyft'i Aç",
  requestingRideCreates: 'Sürüş talebi oluşturmak',
  lyftPass: 'Lyft Pass',
  inYourApp: 'oluşturur:',
  activePassMessage: 'Lyft üzerinde aktif bir pasınız var.',
  noAccount: 'Lyft hesabınız yok mu?',
  download: 'İndir',
  andRegister: 've şimdi kayıt olun.',
  infoBox: {
    usableFor: 'Lyft Standard veya Lyft XL için kullanılabilir',
    coversUpTo: "250$'a kadar kapsar (%20 bahşiş dahil)",
    validOnlyFor: 'Sadece {country} içindeki yolculuklar için geçerlidir',
  },
  verificationCode: {
    title: 'Doğrulama Kodu',
    description: 'Lyft Pass oluşturabilmemiz için Lyft hesabınızla ilişkili telefon numarasını doğrulayın.',
    instruction: 'Telefon numaranıza gönderilen 4 haneli doğrulama kodunu girin.',
    placeholder: 'Doğrulama kodu',
    resendIn: 'Kodu almadınız mı? {seconds} saniye içinde tekrar gönderin.',
    didntReceive: 'Kodu almadınız mı?',
    send: 'Gönder',
    requestNew: 'Yeni iste',
  },
  lyftPhone: {
    title: 'Lyft Hesabınızla İlişkili Telefon Numarası',
    description:
      'Garantili Sürüş talebinde bulunmak için lütfen Lyft hesabınızla ilişkili telefon numarasını onaylayın.',
    placeholder: 'Telefon Numarası',
    noAccount: 'Lyft hesabınız yok mu?',
    download: 'İndir',
    registerNow: 'telefonunuza indirin ve şimdi kaydolun.',
    alternative:
      'Alternatif olarak, numaranızı şimdi gönderebilir ve daha sonra bu numarayla bir Lyft hesabı oluşturabilirsiniz. Lyft Pass otomatik olarak hesabınızda oluşturulacaktır.',
    confirmNumber: 'Numarayı Onayla',
  },
  errors: {
    somethingWentWrong: 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
    incorrectCode: 'Yanlış doğrulama kodu. Lütfen tekrar deneyin.',
  },
  success: {
    passCreated: 'Lyft Pass başarıyla oluşturuldu',
    codeSent: 'Doğrulama kodu başarıyla gönderildi',
  },
};
